export function utmResolver(param: string): string | null {
  return new URLSearchParams(window.location.search).get(param);
}
